import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import BookingPage from "./pages/public/BookingPage";
import CancelPage from "./pages/public/CancelPage";
import LoginPage from "./pages/admin/LoginPage";
import AdminLayout from "./pages/admin/AdminLayout";
import DashboardPage from "./pages/admin/DashboardPage";
import SlotsPage from "./pages/admin/SlotsPage";
import SchedulePage from "./pages/admin/SchedulePage";
import BookingsPage from "./pages/admin/BookingsPage";
import LinksPage from "./pages/admin/LinksPage";
import { useAuth } from "./store/auth";

function RequireAuth({ children }) {
  const isAuthenticated = useAuth((s) => s.isAuthenticated());
  return isAuthenticated ? children : <Navigate to="/admin/login" replace />;
}

export default function App() {
  return (
    <Routes>
      {/* Public, login-free booking. /b/<code> is the short link; /book/<token> stays for legacy links. */}
      <Route path="/b/:token" element={<BookingPage />} />
      <Route path="/book/:token" element={<BookingPage />} />
      <Route path="/cancel/:token" element={<CancelPage />} />

      {/* Admin */}
      <Route path="/admin/login" element={<LoginPage />} />
      <Route
        path="/admin"
        element={
          <RequireAuth>
            <AdminLayout />
          </RequireAuth>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="slots" element={<SlotsPage />} />
        <Route path="schedule" element={<SchedulePage />} />
        <Route path="bookings" element={<BookingsPage />} />
        <Route path="links" element={<LinksPage />} />
      </Route>

      <Route path="/" element={<Navigate to="/admin" replace />} />
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
}
